<template lang="pug">
    v-dialog(v-model="dialog" max-width="640" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(absolute :value="fetching")
                v-progress-circular(indeterminate size="64")
            v-sheet.pa-4.primary.lighten-2
                v-text-field(v-model='search' :label="$t('pages.sheet.dropFile.searchFolder')" dark flat solo-inverted
                hide-details clearable clear-icon='mdi-close-circle-outline' prepend-icon="mdi-magnify")
            v-card-title(v-if="false") {{title}}
            v-card-text
                template(v-if="items.length > 0")
                    v-treeview(:items='items' selected-color='indigo' hoverable :search="search" :filter="filter" return-object
                    shaped activatable transition expand-icon='mdi-chevron-down' :active.sync="active" dense)
                        template(#prepend="{item, active, open}")
                            v-icon {{open ? 'mdi-folder-open' : 'mdi-folder'}}
                        template(#label="{item}")
                            span {{item.name}}
                            span(v-if="item.view_type").font-weight-bold &nbsp;({{item.view_type}})
                template(v-else)
                    .text-center.my-5
                        v-label {{$t('pages.sheet.dropFile.directoryIsEmpty')}}
            v-layout(tag="v-card-actions")
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(@click="onSubmit" color="primary" depressed :disabled="!folderIsValid").px-3
                    v-icon(left dark) mdi-check
                    | {{$t('general.ok')}}
</template>

<script>
import { translateMonth, translateYear, dateFormat } from "../../utils";

export default {
  name: "FolderPickerDialog",
  props: {
    title: String
  },
  data() {
    return {
      dialog: false,
      fetching: false,
      items: [],
      active: [],
      search: null
    };
  },
  computed: {
    folderIsValid() {
      if (this.active.length === 1) {
        return this.active[0].selectable;
      }
      return false;
    },
    filter() {
      return (item, search, textKey) =>
        item[textKey].toLowerCase().includes(search.toLowerCase());
    }
  },
  watch: {
    search() {
      this.active = [];
    }
  },
  methods: {
    mapChildren(children = []) {
      for (let i = 0; i < children.length; i++) {
        children[i].name = this.getDisplayName(children[i]);
        this.mapChildren(children[i].children);
      }
    },
    close() {
      this.dialog = false;
      this.active = [];
      this.search = null;
    },
    show(calendarId) {
      this.dialog = true;
      this.items = [];
      this.fetching = true;
      this.axios
        .get(`calendars/${calendarId}/folders`)
        .then(res => {
          this.items = [...res.data];
          this.mapChildren(this.items);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    onSubmit() {
      if (this.folderIsValid) {
        this.$emit("submit", { ...this.active[0] });
      } else {
        this.$toasted.error(this.$t("general.somethingWrong"), {
          icon: "mood_bad"
        });
      }
      this.close();
    },
    getDisplayName(obj) {
      let text = obj.name;
      if (obj.level === "year") {
        text = translateYear(obj.sequence);
      } else if (obj.level === "month") {
        text = translateMonth(
          new Date(new Date().getFullYear(), obj.sequence - 1),
          true,
          true
        );
      } else if (obj.level === "period" || obj.level === "week") {
        text =
          obj.start_from === obj.end_to
            ? dateFormat(obj.start_from)
            : dateFormat(obj.start_from) + " - " + dateFormat(obj.end_to);
        if (obj.level === "week") {
          text = `Week ${(obj.sequence + "").padStart(2, "0")} : ` + text;
        }
      }
      return text + "";
    }
  }
};
</script>

<style scoped></style>
